import React from 'react'

const HeaderPages = ({ img, alt }) => {
  return (
    <img src={img} className='d-block headerPagesConainer__image' alt={alt} loading="lazy" />
  )
}

export default HeaderPages